package er.prateek.crossly.persistence

/**
 * The counters behind ad pacing. Persisted rather than held in memory because the caps that
 * matter most to a player -- "not again so soon", "not more than N today" -- are exactly the
 * ones a relaunch would otherwise reset, and force-quitting after every ad is a real habit.
 */
data class AdFrequencyState(
    /** Drives [er.prateek.crossly.ads.InterstitialConfig.minPuzzlesBeforeFirst]. */
    val puzzlesCompletedLifetime: Int = 0,
    val puzzlesSinceLastInterstitial: Int = 0,
    /** 0 means "never shown", which reads as infinitely long ago. */
    val lastInterstitialEpochMs: Long = 0L,
    /** ISO date the daily counters below belong to; a different date resets them. */
    val dayKey: String = "",
    val interstitialsToday: Int = 0,
    val rewardedToday: Int = 0,
)

interface AdsPrefsStore {
    fun load(): AdFrequencyState
    fun save(state: AdFrequencyState)
}
